import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseURL } from "@/config/APIConfig";

export const getSideBarNavigationList = createAsyncThunk(
    "sidebarNavigation/getSideBarNavigationList",
    async (payload, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams(payload).toString();

            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                `${baseURL.live}v1/CompanyNavigationSetup/GetSideBarCompanyNavigationList?${queryParams}`,
                // `${baseURL.live}v2/NavigationSetup/GetSideBarNavigationList?${queryParams}`,
                {
                    headers: {
                        ...(token && {
                            Authorization: `Bearer ${token}`,
                        }),
                    },
                },
            );

            const result = response.data;

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result.data ?? [];
            }

            return rejectWithValue(result);
        } catch (error) {
            return rejectWithValue(
                error.response?.data || error.message || "Something went wrong",
            );
        }
    },
);
